// extracted by mini-css-extract-plugin
module.exports = {"base":"ScrollWrapper_base__Ky8il","scrolled":"ScrollWrapper_scrolled__43Y5h","hidden":"ScrollWrapper_hidden__DdNcD"};